<template>
    <v-navigation-drawer stateless value="true" class="catalog-navigation catalog-navigation--max">
        <v-toolbar text color="white">
            <v-toolbar-title>
                <v-text-field
                    label="Поиск"
                    solo
                    text
                    single-line
                    class="mb-0"
                    prepend-icon="search"
                    hide-details/>
            </v-toolbar-title>
            <v-spacer/>
            <v-menu bottom left>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                        <v-icon>more_vert</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item @click="addStockR">
                        <v-list-item-title>Добавить</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-toolbar>
        <v-list v-if="getStockRegisters.length > 0" class="v-list--booking">
            <v-list-item
                :key="stockR.id"
                active-class="active"
                v-if="!stockR.deleted"
                v-for="stockR in getStockRegisters"
                @click="editStockR(stockR.id)"
                :class="`v-list--booking_state f-width ${$route.params.stockRegId === stockR.id ? 'active' : ''}`">
                <v-list-item-title v-text="stockR.name"/>
                <v-list-item-action>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon @click.prevent="stockRChangeStatus(stockR.id, stockR.status)" v-on="on">
                                <v-icon>{{ stockR.status ? 'remove_red_eye' : 'visibility_off' }}</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ stockR.status ? 'Активен' : 'Не активен' }}</span>
                    </v-tooltip>
                </v-list-item-action>
            </v-list-item>
        </v-list>
        <empty v-else/>
    </v-navigation-drawer>
</template>

<script>
    import { mapGetters } from 'vuex'
    import StockRegister from '../../../../api/stockregister'
    import Empty from '../../../../components/Loader/Empty'

    export default {
        name: 'stockRegisterNavigation',
        components: { Empty },
        methods: {
            addStockR () {
                this.$router.push({ name: 'addStockRegister' })
            },
            editStockR (id) {
                this.$router.push({
                    name: 'editStockRegister',
                    params: { stockRegId: id }
                })
            },
            stockRChangeStatus (id, status) {
                StockRegister
                    .changeStatus({
                        id,
                        status
                    })
                    .then(response => {
                        this.$store.commit('changeStockRegisterStatus', response.data.data)
                        this.$store.commit('showSnackbar', {
                            text: 'Статус акции изменен',
                            color: 'success'
                        })
                    })
                    .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
            }
        },
        computed: {
            ...mapGetters([
                'getStockRegisters'
            ])
        }
    }
</script>
